declare global {
  interface Window {
    __inspectReactDomMutationGuardInstalled?: boolean;
  }
}

/**
 * Patches Node.removeChild and Node.insertBefore so React does not crash when
 * external DOM mutation (browser translate, extensions) desyncs the fiber tree.
 * Install once before React mounts.
 */
export function installReactDomMutationGuard(): void {
  if (typeof window === 'undefined' || typeof Node === 'undefined' || !Node.prototype) {
    return;
  }
  if (window.__inspectReactDomMutationGuardInstalled) {
    return;
  }
  window.__inspectReactDomMutationGuardInstalled = true;
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      if (child.parentNode) {
        return originalRemoveChild.call(child.parentNode, child) as T;
      }
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(
    newNode: T,
    referenceNode: Node | null
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return originalInsertBefore.call(this, newNode, null) as T;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
